import { InlineText1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import * as styles from './BetPosition.css';
import { Preloader } from '@cian/preloader-component';
import { mergeStyles } from '@cian/utils';

interface IBetPositionProps {
  isLoading: boolean;
  isDataEmpty: boolean;
  serviceName: string;
  pagePosition: number | null;
  offerPosition: number | null;
}

export const BetPosition = ({
  isLoading,
  isDataEmpty,
  serviceName,
  pagePosition,
  offerPosition,
}: IBetPositionProps) => {
  return (
    <div className={styles['wrapper']}>
      {isLoading && (
        <div {...mergeStyles(styles['loader-wrapper'], isDataEmpty && styles['empty-loader-wrapper'])}>
          <Preloader size={24} preloaderStyle={styles['loader']} />
        </div>
      )}

      {!!pagePosition && (
        <div>
          <InlineText1>
            Вы на <span className={styles['count']}>{pagePosition}</span> странице поиска.
          </InlineText1>
        </div>
      )}

      {!!offerPosition && (
        <div className={styles['offer-position']}>
          <InlineText1>
            Над вами <span className={styles['count']}>{offerPosition}+</span> {serviceName}.
          </InlineText1>
        </div>
      )}

      {offerPosition === 0 && (
        <div className={styles['offer-position']}>
          <InlineText1>Вы будете первым среди {serviceName}.</InlineText1>
        </div>
      )}
    </div>
  );
};
